import { useRef } from 'react';
import { WizardStorage, WizardStorageData } from '../interfaces/wizard-step';

export function useWizardStorage<T extends object = object>(
  initialCache: Map<string, WizardStorageData<T>> = new Map()
): WizardStorage<T> {
  const cache = useRef(initialCache);

  const getStoredData = (key: string) => {
    const dataFromCache = cache.current.get(key);

    if (!dataFromCache) {
      return null;
    }

    return dataFromCache;
  };

  const store = (key: string, data: WizardStorageData<T>) => {
    cache.current.set(key, data);
  };

  return {
    getStoredData,
    store
  };
}
